import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import {
  GroupLayout,
  JsonFormsRendererRegistryEntry,
  LayoutProps,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import { JsonFormsDispatch, withJsonFormsLayoutProps } from '@jsonforms/react';

export const GroupControl: JsonFormsRendererRegistryEntry = {
  tester: rankWith(
    1, // positive is a match, negative is not
    uiTypeIs('Group')
  ),
  renderer: withJsonFormsLayoutProps((props: LayoutProps) => {
    const groupUiSchema = props.uischema as GroupLayout;
    return (
      <View>
        <Text style={styles.groupLabel}>{props.label}</Text>
        {groupUiSchema.elements && groupUiSchema.elements.length > 0 && (
          <View>
            {
              // render the child elements in the group
              groupUiSchema.elements.map((child, key) => (
                <View key={key}>
                  <JsonFormsDispatch {...props} uischema={child} />
                </View>
              ))
            }
          </View>
        )}
      </View>
    );
  }),
};

const styles = StyleSheet.create({
  groupLabel: {
    marginBottom: 30,
    fontWeight: 'bold',
  },
});
